import wixWindow from 'wix-window';


$w.onReady(function () {

if(wixWindow.formFactor === "Mobile"){
  $w("#tickerHeaderDivGroupMobile").show();
}


});